module.exports = __webpack_public_path__ + "media/src/assets/Images/alert-octagon-c950d6824c9f23adc1224ac7b8755172.svg";